// Streaming Ollama response (token by token)
export async function streamOllamaResponse({ prompt, model = 'llama3', apiUrl = 'http://localhost:11434/api/chat', onToken, onDone, onError }) {
  try {
    const res = await fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        model,
        messages: [{ role: 'user', content: prompt }],
        stream: true
      })
    });
    if (!res.body) throw new Error('No response body');
    const reader = res.body.getReader();
    let partial = '';
    const decoder = new TextDecoder();
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      const chunk = decoder.decode(value, { stream: true });
      for (const line of chunk.split('\n')) {
        if (!line.trim()) continue;
        try {
          const obj = JSON.parse(line);
          const token = obj.message?.content || obj.response || '';
          if (token) {
            partial += token;
            if (onToken) onToken(token, partial);
          }
        } catch (e) {
          // Ignore parse errors (incomplete JSON)
        }
      }
    }
    if (onDone) onDone(partial);
  } catch (err) {
    if (onError) onError(err);
  }
}
